module.exports = __webpack_public_path__ + "media/images/referral5-f74bb46c.png";